import React from 'react';

import { Link } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import { SwipeableDrawer } from '@material-ui/core';

import HomeIcon from '@material-ui/icons/Home';
import HistoryIcon from '@material-ui/icons/History';
import FavoriteIcon from '@material-ui/icons/Favorite';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  listItem: {
    color: 'inherit',
  }
}));

export default function SideMenu(props) {
  const classes = useStyles();

  const menuItems = [
    {
      'id': 1,
      'title': 'Menu principal',
      'subtitle': 'Retorne à página inicial',
      'icon': <HomeIcon />,
      'link': '/',
    },
    {
      'id': 2,
      'title': 'Últimas buscas',
      'subtitle': 'Verifique suas buscas recentes',
      'icon': <HistoryIcon />,
      'link': '/recent-searches',
    },
    {
      'id': 3,
      'title': 'Favoritos',
      'subtitle': 'Materiais salvos como favoritos',
      'icon': <FavoriteIcon />,
      'link': '/bookmarks',
    },
    {
      'id': 4,
      'title': 'Bibliotecas',
      'subtitle': 'Sobre as bibliotecas do SISBI',
      'icon': <LocalLibraryIcon />,
      'link': '/libraries',
    },
    {
      'id': 5,
      'title': 'Sobre o Bibliotecas UFRN',
      'subtitle': 'Informações sobre este aplicativo',
      'icon': <InfoIcon />,
      'link': '/about',
    },
  ];
 
  return (
    <SwipeableDrawer open={props.sideMenuState} onClose={props.onClose} onOpen={props.onOpen}>
      <div
        role="presentation"
        onClick={props.onClick}
        onKeyDown={props.onClick}
      >
        <List
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Opções
            </ListSubheader>
          }
        >
          {menuItems.map(menuItem => (
              <ListItem 
                button
                divider={true} 
                key={menuItem.id} 
                component={Link} 
                to={menuItem.link} 
                className={classes.listItem}
              >
                <ListItemIcon>
                  {menuItem.icon}
                </ListItemIcon>
                <ListItemText primary={menuItem.title} secondary={menuItem.subtitle} />
              </ListItem>
          ))}
        </List>
      </div>
    </SwipeableDrawer>
  );
}